import { Box } from '@mui/material';
import { Heading, Base } from '@natomalabs/natomui/src/components/Typography';
import type { ReactNode } from 'react';

export default function LoginStatusForm({
  title,
  message
}: {
  title: string;
  message: ReactNode;
}) {
  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        width: theme.spacing(50),
        textAlign: 'center',
        padding: theme.spacing(4)
      })}
    >
      <Heading>{title}</Heading>
      <Base color="text.secondary">{message}</Base>
    </Box>
  );
}
